<template>
	<div id="main_div">

		<MainMenu :dentations="dentations" :bones="bones" :nerves="nerves" :airways="airways" :allTeeth="allTeeth"
			:implants="implants" :crowns="crowns" :currentStages="currentStages" :treatmentStages="treatmentStages"
			:shortLink="shortLink" :shareLink="shareLink" :readonlyLink="readonlyLink" :isStitched="isStitched"
			:isIntraoral="isIntraoral" :isIntraoralView="isIntraoralView" :isEngineerMode="isEngineerMode"
			:isHighQuality="isHighQuality" :hasDicom="hasDicom" :isNoTeeth="isNoTeeth" :isViewMode="isViewMode"
			:isDicomOpen="isDicomOpen" :dicomLowLink="dicomLowLink" :dicomMiddleLink="dicomMiddleLink"
			:dicomHighLink="dicomHighLink" :isMobileDevice="isMobileDevice" :isValidTreatment="isValidTreatment" />

		<div id="views_cont" class="flex-container">
			<div id="views3d_wrapper" class="flex-item">
				<div id="views3d_cont">
					<div id="stl_wrapper" class="view-flex-item" v-show="!isDicom3DView || isSplitView">
						<div id="stl_cont">
						</div>

						<div class="cbct-zoom-container" v-show="isStlLoaded">
							<img src="images/white_plus.png" class="cbct-zoom-btn" v-on:click="changeZoom(1)"
								title="Increase Zoom" />
							<img src="images/white_minus.png" class="cbct-zoom-btn" v-on:click="changeZoom(-1)"
								title="Decrease Zoom" />
							<!-- <img src="images/reset.png" class="dicom-zoom-btn" v-on:click="resetZoom()" title="Reset" /> -->
						</div>

						<div id="isStitchingHint" v-show="isStitching || isSaving">
							<!-- <span v-show="viewMode.isSaving"> Case saving...</span> -->
							<span> {{ isStitching ? 'Stitching in progress...' : 'Saving changes...' }} </span>
							<img class="progress-small-img" src="images/dark-blue-spinner.gif" />
						</div>

						<img id="teethListBtn" ref="teethListBtn" data-toggle="collapse" data-target="#teethListPanel"
							aria-expanded="false" title="Settings" src="images/menu_white.png"
							class="teeth-list-btn teeth-list-ctrl" />

						<TeethListPanel :viewSourceType="viewSourceType" :isStitching="isStitching"
							:isStitched="isStitched" :isDicomOpen="isDicomOpen" :allItems="allItems"
							:hasClosedBones="hasClosedBones" :isAnnotationMode="isAnnotationMode"
							:isOnlyTeeth="isOnlyTeeth" :isNoTeeth="isNoTeeth" :isViewMode="isViewMode"
							:savedData="savedData" />

						<ShowHideControls />
						<ColorControls />
						<input id="selectColorControl" type="text" class="coloris" value="#ffffff" />

						<OpacityMode />

						<SaveButtons />
						<BottomPanel :fromShareLink="fromShareLink" :isViewMode="isViewMode"
							:allowDownloads="allowDownloads" v-show="isStlLoaded" />

						<div id="viewModeHint" v-if="isViewMode">VIEW MODE</div>
					</div>
					<div id="dicom_3d_wrapper" class="view-flex-item" v-show="isDicom3DView || isSplitView">
					</div>
					<!-- <img id="segmented_view_btn" class="switch-view-btn" v-show="isDicomLoaded"
						v-on:click="switchSegmentedView"
						:src="isSegmentedView ? 'images/3d_red.png' : 'images/3d_white.png'" title="Segmented View"> -->

					<img id="dicom_view_btn" class="switch-view-btn"
						v-show="isDicomLoaded && isDicomOpen && !isSplitView" v-on:click="switchDicom3dView"
						:src="isDicom3DView ? 'images/dicom_red.png' : 'images/dicom_white.png'" title="Dicom 3D View">

					<img v-if="!isMobileDevice" id="split_view_btn" class="switch-view-btn"
						v-show="isDicomLoaded && isDicomOpen" v-on:click="switchSplitView"
						:src="isSplitView ? 'images/split_red.png' : 'images/split_white.png'" title="Split View">
				</div>
			</div>

			<!--<DicomViewer :app="{ divId: 'demo_dicom', orientation: 'axial', toolName: 'dragDrop', color: 'red' }"
				style="width: 49%; height: 100%; display: block;" /> -->
		</div>

		<div id="open_json" class="custom-file" style="display:none">
			<input id="input_json" type="file" class="custom-file-input" onchange="loadJson();" accept="*.json" />
			<label class="custom-file-label" for="input_json">Open JSON configuration</label>
		</div>

		<img id="globalSpinner" class="centered-spinner" src="images/dark-blue-spinner.gif" />

		<div id="loader">
			<img id="loaderImage" src="images/Spinner-2.1s-200px.gif" />
			<div id="loaderText">Loading data... Please wait</div>
			<div id="loaderText2"></div>
			<div id="loaderText3"></div>
		</div>


		<div id="annotation-add-menu" class="annotation-menu">
			<button id="annotation-add-btn">Add Layer</button>
			<button id="annotation-clone-closest-btn">Clone Closest Layer</button>
			<button id="annotation-clone-btn">Clone Last Edited</button>
		</div>

		<div id="annotation-tooth-menu" class="annotation-menu">
			<button id="annotation-assign-btn">Assign Layer</button>
			<button id="annotation-delete-btn">Delete Layer</button>
			<button id="tooth-focus-btn">Focus Tooth</button>
			<button id="tooth-edit-btn">Edit Tooth</button>
		</div>

		<div id="cbct-tooth-menu" class="tooth-menu">
			<button id="cbct-color-btn" class="tooth-menu-btn">Change Color</button>
			<button id="cbct-delete-btn" class="tooth-menu-btn">Delete Tooth</button>
			<button id="cbct-change-btn" class="tooth-menu-btn">Edit Number</button>
			<button id="cbct-focus-btn" class="tooth-menu-btn">Focus Tooth</button>
			<button id="cbct-hide-btn" class="tooth-menu-btn">Hide Tooth</button>
			<button id="cbct-reset-initial-btn" class="tooth-menu-btn">Reset to initial</button>
			<button id="cbct-reset-current-btn" class="tooth-menu-btn">Reset to current</button>
		</div>

		<div id="intraoral-tooth-menu" class="tooth-menu">
			<button id="intraoral-add-btn" class="tooth-menu-btn">Add Tooth</button>
			<button id="intraoral-add-border-btn" class="tooth-menu-btn">Add Border</button>
			<button id="intraoral-delete-border-btn" class="tooth-menu-btn">Remove Border</button>
			<button id="intraoral-focus-btn" class="tooth-menu-btn">Focus on Tooth</button>
			<button id="intraoral-delete-btn" class="tooth-menu-btn">Delete Tooth</button>
			<button id="intraoral-change-btn" class="tooth-menu-btn">Edit Number</button>
			<button id="intraoral-center-btn" class="tooth-menu-btn">Center View</button>
			<button id="intraoral-flip-btn" class="tooth-menu-btn">Flip View</button>
		</div>

		<OrthoPlanMode v-if="isStlLoaded" :isIntraoral="isIntraoral" :currentStages="currentStages"
			:treatmentStages="treatmentStages" />

		<img v-if="!isMobileDevice" id="trademarkImg" src="images/Logo_ORCA_White_100_height.png" />
		<!-- <img id="infoImgBtm" src="images/info_icon_white.png" title="Help" v-on:click="showHelp()" /> -->
		<div id="copyrightText">Copyright &copy; 2025 ORCA Dental AI LTD, All rights reserved</div>

		<!-- Modal -->
		<ImplantStep1 :lengths="lengths" :diameters="diameters" @set-implant-name="setImplantName" />
		<ImplantStep2 :lengths="lengths" :diameters="diameters" :toothModels="toothModels" :isResize="isResize"
			@set-implant-size="setImplantSize" @add-implant="addImplant" />
		<ImplantStep3 @add-implant="addImplant" @add-crown="addCrown" :isCrownPlacement="isCrownPlacement" />
		<AddCrownMap @set-crown-number="setCrownNumber" @add-crown="addCrown" />
		<Loader :patientFirstName="patientFirstName" :patientLastName="patientLastName" />
		<MarketingPrompt :startmarketingprompt="startmarketingprompt" :opennewtabprompt="opennewtabprompt" />
		<ShareParamsDialog :shortLink="shortLink" />
		<OrthoPlayStages :orthoStages="orthoStages" :isOrthoPlaying="isOrthoPlaying" />
		<OrthoTreatmentStages :treatmentStages="treatmentStages" :isTreatmentPlaying="isTreatmentPlaying" />
		<ClipDialog />
		<ReportsDialog />
		<ExportDialog :exportUrlType="exportUrlType" />
		<AnchorageWizard />

	</div>
</template>

<script>

//#region Imports

import { loadStlModels, checkHasDicom } from "./components/appStart/loader";
import { startIsStitchingWatch, checkIsStitched, switchStitching } from "./components/appStart/stitching";
import MainMenu from "./components/controls/MainMenu.vue";

import TeethListPanel from "./components/controls/TeethListPanel.vue";
import { ISO, UNS, ALPHANUM } from "./components/tooth/teethNaming.js";
import { focusItem, unfocusItem, editItemSettings, deleteItem } from './components/controls/TeethListManager';

import ImplantStep1 from "./components/implants/ImplantStep1.vue";
import ImplantStep2 from "./components/implants/ImplantStep2.vue";
import { initStep2 } from "./components/implants/ImplantStep2.vue";
import ImplantStep3 from "./components/implants/ImplantStep3.vue";

import ShareParamsDialog from "./components/share/ShareParamsDialog.vue";
import ClipDialog from "./components/reports/ClipDialog.vue";
import { applyClipData } from "./components/reports/ClipDialog.vue";
import ReportsDialog from "./components/reports/ReportsDialog.vue";
import ExportDialog from "./components/reports/ExportDialog.vue";

import AddCrownMap from "./components/crowns/AddCrownMap.vue";
import { addCrownStl } from "./components/crowns/addCrown.js";
import { addImplantStl } from "./components/implants/addImplant.js";

import AnchorageWizard from "./components/anchorage/AnchorageWizard.vue";
import { generateRootCrownMeshes } from "./components/anchorage/AnchorageCalculation.js";

import {
	b64_to_utf8,
	utf8_to_b64,
	saveViewerData,
	sendReport,
	sendShareReport,
	loadViewerDataFromApi,
	updateZipsForSourceType
} from "./components/saveLoadData";
import {
	sendGetExportDataRequest,
} from "@/api/reportApi";
import {
	getTimeStamps,
} from "@/api/toothApi";
import {
	sendSetGuidsRequest,
} from "@/api/inputJsonApi";
import { showHelpDialog } from "./components/help/HelpManager.js";
import { getMouse3dDirection } from "./components/geometry/editObject";
import { adjustModel, updateToothDentition } from "./components/appStart/adjustModel";
import { airwaySetColor } from "./components/airway/AirwayColor";

import { loadDicom3D } from "./components/vtk/Dicom3dManager";
import { loadGingivaCrossData } from "./components/geometry/gingivaHelper";

import Loader from "./components/controls/Loader.vue";
import MarketingPrompt from "./components/controls/MarketingPrompt.vue";
import BottomPanel from "./components/controls/BottomPanel.vue";
import OpacityMode from "./components/opacity/OpacityMode.js";
import ShowHideControls from "./components/showHide/ShowHideControls.vue";
import ColorControls from "./components/color/ColorControls.vue";
import SaveButtons from "./components/controls/SaveButtons.vue";
import OrthoPlanMode from "./components/ortho/OrthoPlanMode.js";

import {
	OrthoPlanMode as opmode, downloadOrhoStages,
	resetToInitial,
	resetToCurrent,
	loadTreatmentMatrixs
} from "./components/ortho/OrthoPlanMode.js";

import {
	fetchTreatmentStages, restoreDefaultGeometries
} from "./components/ortho/OrthoTreatment.js";

import OrthoPlayStages from "./components/ortho/OrthoPlayStages.vue";
import OrthoTreatmentStages from "./components/ortho/OrthoTreatmentStages.vue";
import DicomViewer from "./components/dicom/DicomViewer.vue";
import { highlightOutlines } from "./components/dicom/slice.js";

import {
	showIoViewer
} from "./components/intraoral/IntraoralManager";
import { leaveHideMode } from "./components/showHide/showHideMode.js";

import {
	ioViewer,
	ioPlane,
	allModels,
} from "./components/intraoral/IntraoralManager";
import { globalPlanes, empty } from "@/components/reports/ClipDialog.vue";

//#endregion

export default {
	name: "app",
	data() {
		return {
			baseObj: null,
			stlBaseUrl: null,
			stlCopyUrl: null,
			clearCache: false,
			isHighQuality: true,
			isAnnotationMode: false,
			isEngineerMode: false,
			hasDicom: false,
			isStitched: false,
			isStitching: false,
			viewSourceType: "cbct",
			exportUrlType: "nonStitchedUrl",
			isSaving: false,
			isOrthoPlaying: false,
			isIntraoral: false,
			isIntraoralView: false,
			isCbctParam: false,
			isStlLoaded: false,
			isDicomLoaded: false,
			isSegmentedView: true,
			isSplitView: false,
			isDicom3DView: false,
			isDicomOpen: false,
			isOnlyTeeth: false,
			isNoTeeth: false,
			hasClosedBones: false,
			showTeethRoots: false,
			isMobileDevice: false,
			defaultFont: null,
			dicomLowLink: false,
			dicomMiddleLink: false,
			dicomHighLink: false,
			dicomData: {},

			isGlb: false,
			activeMode: null,
			teethNaming: ISO,
			cache: null,
			jsonLocation: null,
			isShareEnabled: true,
			fromShareLink: false,
			allowDownloads: true,
			shareLink: window.location.href,
			shortLink: null,
			readonlyLink: `${window.location.href}?save=false`,
			apiPath: window.location.origin,
			prefix: "DEV",
			viewerServerUrl: window.location.origin,
			crownsPath: `${window.location.href.split(/[?#]/)[0]}/stl/crowns`,
			patientId: 0,
			patientFirstName: "Unknown Client",
			patientLastName: "",
			isAnonymized: false,
			doctorName: "",
			showmarketingprompt: false,
			startmarketingprompt: false,
			opennewtabprompt: "http://cephx.com",
			dentations: [],
			bones: [],
			nerves: [],
			gingivae: [],
			airways: [],
			implants: [],
			crowns: [],
			orthoStages: [],
			treatmentStages: [],
			isValidTreatment: false,
			isTreatmentPlayMode: false,
			isTreatmentPlaying: false,
			currentTreatmentStage: null,
			originalTreatmentStage: null,
			currentStageId: -1,
			implantsColor: "#FFC0CB",
			crownsColor: "#FFC0CB",
			bonesColor: "#9A9899",
			bonesOpacity: 1,
			nervesColor: "#FF0000",
			nervesOpacity: 1,
			gingivaeColor: "#FFB6C1",
			gingivaeOpacity: 0.85,
			airwaysColor: "#FFFFFF", //"#BA68C8",
			airwaysOpacity: 1,
			teethColor: "#FFFFFF", //"#D0CECF",
			teethOpacity: 1,
			isRandomTeethColor: false,
			zipFile: null,
			zipSegmentation: null,
			isHideMode: false,
			isColorMode: false,
			isOpacityMode: false,
			isAutoRotated: false,
			isCrownPlacement: false,
			lengths: [],
			diameters: [],
			toothModels: [],
			newImplantName: null,
			newImplantLength: 0,
			newImplantDiameter: 0,
			newImplantCrownId: null,
			crownImplantId: null,
			crownNumber: null,
			midlineData: [],
			isResize: false,
			isOcclusal: false,
			isViewMode: false,
			isReset: false,
			isAnonymized: false,
			is3DAllowed: true,
			isCompany: true,
			loaderClosed: false,
			simplifyPercent: 25,
			savedData: {
				isLoaded: false,
				isRandomTeethColor: false,
				cameraPosition: null,
				cameraTarget: null,
				clipData: null,
				bonesColor: null,
				bonesOpacity: null,
				teethColor: null,
				teethOpacity: null,
				bones: [],
				dentations: [],
				implants: [],
				crowns: [],
				gingivae: [],
				airways: [],
				nerves: []
			},
			baseData: {
				isLoaded: false,
				cameraPosition: null,
				cameraTarget: null,
				bonesColor: null,
				bonesOpacity: null,
				teethColor: null,
				teethOpacity: null,
				bones: [],
				dentations: [],
				implants: [],
				crowns: [],
				gingivae: [],
				airways: [],
				nerves: []
			}
		};
	},
	components: {
		MainMenu,
		TeethListPanel,
		ImplantStep1,
		ImplantStep2,
		ImplantStep3,
		AddCrownMap,
		Loader,
		MarketingPrompt,
		BottomPanel,
		OpacityMode,
		ShowHideControls,
		ColorControls,
		OrthoPlanMode,
		OrthoPlayStages,
		OrthoTreatmentStages,
		ShareParamsDialog,
		ClipDialog,
		ReportsDialog,
		ExportDialog,
		AnchorageWizard,
		SaveButtons,
		DicomViewer
	},
	methods: {
		initApp: async function (obj) {
			let isMobileOrTablet = mobileAndTabletCheck();
			vueApp.isMobileDevice = isMobileOrTablet;

			$("#orthoMenu").css({ display: "none" });
			vueApp.baseObj = obj;

			let versionKey = `orcaViewerVersion`;
			let versionValue = localStorage.getItem(versionKey);
			if (!versionValue || versionValue != cephxVersion) {
				this.clearCache = true;
				localStorage.setItem(versionKey, cephxVersion);
			}

			if (obj.defaultSettings) {
				this.bonesColor = obj.defaultSettings.bonesColor;
				this.bonesOpacity = obj.defaultSettings.bonesOpacity;
				this.nervesColor = obj.defaultSettings.nervesColor;
				this.nervesOpacity = obj.defaultSettings.nervesOpacity;
				// this.teethColor = obj.defaultSettings.teethColor;
				this.teethOpacity = obj.defaultSettings.teethOpacity;
				if (obj.defaultSettings.implantsColor)
					this.implantsColor = obj.defaultSettings.implantsColor;
			}

			if (obj.data) {
				if (obj.data.zipFile) {
					this.zipFile = obj.data.zipFile;
				}
				if (isMobileOrTablet) {
					this.zipFile = obj.data.mobileZip;
					this.intraoralZipUrl = obj.data.mobileSegmentationStandaloneZip;
				}
				else {
					this.zipFile = obj.data.desktopZip;
					this.intraoralZipUrl = obj.data.desktopSegmentationStandaloneZip;
				}

				this.isIntraoral = !!this.intraoralZipUrl;

				if (obj.data.patientId) this.patientId = obj.data.patientId;
				if (obj.data.patientFirstName)
					this.patientFirstName = obj.data.patientFirstName;
				if (obj.data.patientLastName)
					this.patientLastName = obj.data.patientLastName;
				if (obj.data.doctorId)
					this.doctorId = obj.data.doctorId;
				if (obj.data.doctorName)
					this.doctorName = obj.data.doctorName;


				if (vueApp.isStitched) {
					// updateZipsForSourceType("cbct");
					startIsStitchingWatch();
				}

				if (!this.zipFile) {
					vueApp.exportUrlType = "iosUrl";
					showIoViewer();
					return;
				}

				adjustModel(obj);
				this.cacheStamp = obj.data.cacheStamp;
				if (this.cacheStamp) {
					console.log(`cacheStamp: ${this.cacheStamp}`);
					let cacheStampName = `cacheStamp_${vueApp.jsonLocation}`;
					let localStamp = +localStorage.getItem(cacheStampName);
					if (!localStamp || localStamp < this.cacheStamp) {
						this.clearCache = true;
						localStorage.setItem(cacheStampName, this.cacheStamp);
					}
				}

				let desktopZipTimeStamp = 0;// timeStampsData.timeStamps
				let timeStampsData = await getTimeStamps(vueApp.patientId);
				if (timeStampsData && timeStampsData.timeStamps) {
					for (var prop in timeStampsData.timeStamps) {
						if (prop.endsWith("desktop.zip"))
							desktopZipTimeStamp = +timeStampsData.timeStamps[prop];
					}
				}
				console.log("desktopZipTimeStamp", desktopZipTimeStamp, timeStampsData);
				let desktopStampName = `desktopZipTimeStamp_${vueApp.patientId}`;
				let localDesktopStamp = +localStorage.getItem(desktopStampName);
				if (localDesktopStamp < desktopZipTimeStamp) {
					this.clearCache = true;
					localStorage.setItem(desktopStampName, desktopZipTimeStamp);
				}
				// else {
				// 	this.clearCache = false;
				// }
				console.log(`clearCache: ${this.clearCache}`);

				this.isGlb = obj.data.isGlb;

				var sl = window.location.href;
				if (obj.data.shareLink) {
					sl = obj.data.shareLink;
				}
				addthis_share.url = this.shareLink = sl;

				this.readonlyLink = sl.endsWith(".json")
					? `${sl}&save=false`
					: `${sl}?save=false`;

				if (window.location.href === this.readonlyLink) {
					this.isViewMode = true;
				}

				if (!this.shortLink) {
					this.shortLink = window.location.href;
					shortLink();
				}

				if (obj.data.crownsPath) {
					this.crownsPath = trim(obj.data.crownsPath, "/");
				} else {
					var href = window.location.href;
					href = href.split(/[?#]/)[0];
					if (href.includes(".html"))
						href = href.substring(0, href.lastIndexOf("/"));
					href = trim(href, "/");
					this.crownsPath = `${href}/stl/crowns`;
				}

				if (
					window.location.href.includes("192.168.0.") ||
					window.location.href.includes("172.30.5.") ||
					window.location.href.includes("localhost")
				) {
					this.viewerServerUrl = "https://localhost:7060";
				}

				var prod_url = ".cephx.com";
				var qa_url = "qa.ceph-x.com";
				if (obj.data.apiPath) {
					this.apiPath = trim(obj.data.apiPath, "/");
				} else if (this.apiPath.includes(prod_url)) {
					this.prefix = "PROD";
					this.apiPath = "https://cloud.cephx.com";
				} else if (this.apiPath.includes(qa_url)) {
					this.prefix = "QA";
					this.apiPath = "https://qa.ceph-x.com";
				} else if (
					this.apiPath.includes("192.168.0.") ||
					this.apiPath.includes("172.30.5.") ||
					this.apiPath.includes("ec2-35-155-116-156.")
				) {
					this.apiPath = "https://qa.ceph-x.com";
					this.prefix = "DEV";
				}
				console.log(`apiPath: ${this.apiPath}`);

				sendGetExportDataRequest((responseData) => {
					vueApp.exportData = responseData;
				});

				if (this.fromShareLink) {
					let rmessage = `PatientId: ${this.patientId},  was accessed by ${this.recepientEmail}, ${this.recepientName}`;
					sendShareReport(rmessage);
				}

				if (obj.data.dentations) {
					obj.data.dentations.forEach(item => {
						item.isVisible = true;
					});
					var groups = obj.data.dentations.reduce((acc, dent) => {
						if (dent.groups)
							dent.groups.forEach(item => {
								item.dentition = dent.name;
							});
						return dent.groups ? acc.concat(dent.groups) : acc;
					}, []);
					var teeth = groups.reduce((acc, group) => {
						if (group.teeth)
							group.teeth.forEach(item => {
								updateToothDentition(item);
							});
						return group.teeth ? acc.concat(group.teeth) : acc;
					}, []);
					teeth.forEach(item => {
						if (!item.number) {
							const parsed = parseInt(item.name, 10);
							if (parsed) {
								item.number = parsed;
							}
						}
						if (!item.savedNumber) {
							item.savedNumber = item.number;
						}
						item.isTooth = true;
						item.isVisible = true;
						if (!item.color) {
							item.color = this.teethColor;
						}
						if (!item.opacity) {
							item.opacity = this.teethOpacity;
						}
						if (!item.addedTag && item.filename.includes("added")) {
							let add_arr = item.filename.split("-");
							item.addedTag = add_arr[1].replace(".stl", "");
							item.fromAnnotation = true;
							// console.log(item.filename, add_arr, item.addedTag, item.fromAnnotation);
						}
					});

					this.dentations = obj.data.dentations;
				}

				let maxillaDentation = this.dentations.find(d => d.name === "Maxilla");
				if (!maxillaDentation) {
					maxillaDentation = {
						name: "Maxilla", groups: []
					};
					this.dentations.push(maxillaDentation);
				}
				let maxillaGroup1 = maxillaDentation.groups.find(g => g.name === "11-19");
				if (!maxillaGroup1) {
					maxillaGroup1 = { name: "11-19", teeth: [] };
					maxillaDentation.groups.push(maxillaGroup1);
				}
				let maxillaGroup2 = maxillaDentation.groups.find(g => g.name === "21-29");
				if (!maxillaGroup2) {
					maxillaGroup2 = { name: "21-29", teeth: [] };
					maxillaDentation.groups.push(maxillaGroup2);
				}

				let mandibleDentation = this.dentations.find(d => d.name === "Mandible");
				if (!mandibleDentation) {
					mandibleDentation = {
						name: "Mandible", groups: []
					};
					this.dentations.push(mandibleDentation);
				}
				let mandibleGroup1 = mandibleDentation.groups.find(g => g.name === "31-39");
				if (!mandibleGroup1) {
					mandibleGroup1 = { name: "31-39", teeth: [] };
					mandibleDentation.groups.push(mandibleGroup1);
				}
				let mandibleGroup2 = mandibleDentation.groups.find(g => g.name === "41-49");
				if (!mandibleGroup2) {
					mandibleGroup2 = { name: "41-49", teeth: [] };
					mandibleDentation.groups.push(mandibleGroup2);
				}

				if (obj.data.bones) {
					obj.data.bones.forEach(item => {
						item.isVisible = true;
						item.isBone = true;
						item.isMaxilla = item.isUpper = item.filename.includes("maxilla");
						if (!item.color) {
							item.color = this.bonesColor;
						}
						if (!item.opacity) {
							item.opacity = this.bonesOpacity;
						}
					});
					this.bones = obj.data.bones;
				}

				if (obj.data.nerves) {
					obj.data.nerves.forEach(item => {
						item.name = item.name.replace("Merged", "Nerve");
						item.isVisible = true;
						if (!item.color) {
							item.color = this.nervesColor;
						}
						if (!item.opacity) {
							item.opacity = this.nervesOpacity;
						}
					});
					this.nerves = obj.data.nerves;
				}

				if (obj.data.gingivae) {
					obj.data.gingivae.forEach(item => {
						item.isVisible = true;
						item.isUpper = item.filename.toLowerCase().includes("upper");
						if (!item.color) {
							item.color = this.gingivaeColor;
						}
						if (!item.opacity) {
							item.opacity = this.gingivaeOpacity;
						}
					});
					this.gingivae = obj.data.gingivae;
				}
				if (obj.data.airways) {
					obj.data.airways.forEach(item => {
						item.isVisible = true;
						item.stlCentered = airwaySetColor;
						item.isFromData = true;
						if (!item.color) {
							item.color = this.airwaysColor;
						}
						if (!item.opacity) {
							item.opacity = this.airwaysOpacity;
						}
					});
					this.airways = obj.data.airways;
				}

				var tempLengths = obj.data.lengths
					? obj.data.lengths
					: [6, 8, 10, 11.5, 13, 15];
				if (tempLengths) {
					tempLengths.forEach((item, index) => {
						var length = { value: item, selected: item == 10 }; //index == Math.floor(tempLengths.length / 2) };
						this.lengths.push(length);
					});
				}

				var tempDiameters = obj.data.diameters
					? obj.data.diameters
					: [3.25, 3.75, 4, 4.2, 5, 6];
				if (tempDiameters) {
					tempDiameters.forEach((item, index) => {
						var diameter = { value: item, selected: item == 4 }; //index == obj.data.diameters ? Math.floor(tempDiameters.length / 2) : 2 };
						this.diameters.push(diameter);
					});
				}

				if (obj.data.is3DAllowed !== undefined) {
					this.is3DAllowed = obj.data.is3DAllowed;
				}

				let algo3dToothInfoUrl = obj.data.midlineJson;
				this.getMidlineData(algo3dToothInfoUrl);
			}

			if (vueApp.isAnonymized) {
				let tempId = vueApp.patientId % 10000;
				vueApp.patientFirstName = `xxx${tempId}`; // vueApp.patientId;
				vueApp.patientLastName = "";
			}

			$("#loaderDialog").modal({
				backdrop: "static",
				keyboard: false
			});

			let i = 1;
			vueApp.allItems.forEach((item) => {
				item.id = i++;
				if (!item.isVisible) Vue.set(item, "isVisible", true);
			});

			let stageModels = [];
			if (obj.stages) {
				stageModels = await fetchTreatmentStages(obj.stages);
			}
			if (vueApp.savedData.isLoaded || (vueApp.isReset && vueApp.isViewMode)) {
				loadStlModels(stageModels);
			} else {
				loadViewerDataFromApi(() => {
					loadStlModels(stageModels);
				});
			}
		},
		switchSplitView: function () {
			this.isSplitView = !this.isSplitView;
			setTimeout(() => {
				if (this.isSplitView) {
					loadDicom3D();
				}
				viewer.do_resize();
			}, 100);
		},
		switchDicom3dView: function () {
			this.isDicom3DView = !this.isDicom3DView;
			vueApp.$emit("isDicom3DViewChanged", this.isDicom3DView);
			setTimeout(() => {
				if (this.isDicom3DView) {
					loadDicom3D();
				} else {
					viewer.do_resize();
				}
			}, 100);
		},
		changeZoom: function (factor) {
			viewer.controls.changeZoom(factor);
		},
		showHelp: function () {
			showHelpDialog();
		},
		getMidlineData: function (algo3dToothInfoUrl) {
			if (!algo3dToothInfoUrl && this.zipFile) {
				let filename = this.zipFile.split("/").pop();
				algo3dToothInfoUrl = this.zipFile.replace(
					vueApp.stlCopyUrl,
					vueApp.stlBaseUrl
				).replace(
					filename,
					"algo3d_tooth_info.json"
				);
			}
			if (algo3dToothInfoUrl && !this.midlineData.length) {
				fetch(algo3dToothInfoUrl)
					.then(response => {
						response.text().then(text => {
							var jsonObj = null;
							try {
								jsonObj = JSON.parse(text);
							} catch (e) {
								console.log(`Invalid JSON: ${algo3dToothInfoUrl}! Error: ${e}`);
								sendReport(`Can't load ${algo3dToothInfoUrl}`);
							}
							if (jsonObj) {
								if (!Array.isArray(jsonObj)) {
									console.log(`${algo3dToothInfoUrl} should contain array!`);
									sendReport(`Can't load ${algo3dToothInfoUrl}`);
								} else {
									this.midlineData = jsonObj;
									this.midlineData.forEach(function (data, index) {
										if (data.bbox && Array.isArray(data.bbox)) {
											var minX, minY, minZ, maxX, maxY, maxZ;
											minX = minY = minZ = maxX = maxY = maxZ = 0;

											data.rotated_bbox = [];

											data.bbox.forEach(function (bb) {
												data.rotated_bbox.push(rotatePoint(bb));
												if (bb.x < minX || !minX) minX = bb.x;
												if (bb.x > maxX || !maxX) maxX = bb.x;
												if (bb.y < minY || !minY) minY = bb.y;
												if (bb.y > maxY || !maxY) maxY = bb.y;
												if (bb.z < minZ || !minZ) minZ = bb.z;
												if (bb.z > maxZ || !maxZ) maxZ = bb.z;
											});

											var currentBox = {
												min: {
													x: minX,
													y: minY,
													z: minZ
												},
												max: {
													x: maxX,
													y: maxY,
													z: maxZ
												}
											};
											data.defaultBox = rotateBox(currentBox);
										} else {
											console.log(
												`${data.tooth_no} doesn't contain correct bbox`
											);
										}

										if (
											data.main_axis &&
											Array.isArray(data.main_axis) &&
											data.main_axis.length > 1
										) {
											data.axisPoint1 = rotatePoint(data.main_axis[0]);
											data.axisPoint2 = rotatePoint(data.main_axis[1]);
										} else {
											console.log(
												`${data.tooth_no} doesn't contain correct main_axis`
											);
										}

										if (data.split) {
											data.splitPoint = rotatePoint(data.split);
										} else {
											console.log(`${data.tooth_no} doesn't contain split`);
										}
									});
								}
							}
						});
					})
					.catch((error) => {
						// console.log(`Error response for ${algo3dToothInfoUrl}. Error: ${error}`);
						// sendReport(`Can't load ${algo3dToothInfoUrl}`);
					});
				;
			}
		},
		removeItem: function (item) {
			if (item.isTooth) {
				this.removeTooth(item);
			} else {
				let index = this.nerves.indexOf(item);
				if (index >= 0) {
					this.nerves.splice(index, 1);
				}
				index = this.gingivae.indexOf(item);
				if (index >= 0) {
					this.gingivae.splice(index, 1);
				}
				index = this.airways.indexOf(item);
				if (index >= 0) {
					this.airways.splice(index, 1);
				}
				index = this.bones.indexOf(item);
				if (index >= 0) {
					this.bones.splice(index, 1);
				}
			}
		},
		removeTooth: function (item) {
			if (item && item.isTooth) {
				for (let dentation of this.dentations) {
					for (let group of dentation.groups) {
						let index = group.teeth.indexOf(item);
						if (index > -1) { // only splice array when item is found
							group.teeth.splice(index, 1);
							// console.log(`removed tooth file: ${item.filename}`);
						}
					}
				}
			}
		},
		addTooth: function (item) {
			if (item && item.isTooth) {
				for (let dentation of this.dentations) {
					for (let group of dentation.groups) {
						const arr = group.name.split('-');
						if (arr.length == 1 || group.name[0] == item.name[0]) {
							group.teeth.push(item);
							// console.log("addTooth group", group.name);
							return dentation;
						}
					}
				}
			}
		},
		applySavedClipData: function () {
			applyClipData(this.savedData.clipData);
		},
		setImplantName: function (name) {
			this.newImplantName = name;
		},
		setCrownNumber: function (number) {
			this.crownNumber = number;
		},
		setImplantSize: function (length, diameter) {
			stlLogMessage(`setImplantSize: ${length}, ${diameter}`);
			this.newImplantLength = length;
			this.newImplantDiameter = diameter;

			if (this.isResize) {
				var scaleX = diameter / editedImplant.diameter;
				var scaleY = length / editedImplant.length;
				var mesh = viewer.get_model_mesh(editedImplant.id);
				var impl = mesh; //.children[0];
				impl.geometry.scale(scaleX, scaleY, scaleX);
				//impl.position.set(-diameter / 2, -length / 2, -diameter / 2);

				editedImplant.diameter = diameter;
				editedImplant.length = length;
				onCameraChange();
			}
		},
		addImplant: function (implantX, implantY, implantZ, isMaxilla) {
			var implant = {
				id: 0,
				isVisible: true,
				name: this.newImplantName,
				crownId: this.newImplantCrownId,
				length: this.newImplantLength,
				diameter: this.newImplantDiameter,
				defaultLength: this.newImplantLength,
				defaultDiameter: this.newImplantDiameter,
				x: implantX,
				y: implantY,
				z: implantZ,
				isMaxilla: isMaxilla,
				dentition: isMaxilla ? "Maxilla" : "Mandible",
				isLoaded: false,
				isFromData: false,
				isImplant: true,
				color: vueApp.implantsColor
			};
			this.newImplantCrownId = null;
			implant.id = vueApp.generateNewItemId();
			this.implants.push(implant);
			$("#globalSpinner").css({ display: "block" });
			stlLogMessage(
				`addImplant: ${this.newImplantName}, ${implantX}, ${implantY}, ${implantZ}`
			);
			addImplantStl(implant);
		},
		loadImplant: function (item) {
			if (item) {
				//console.log(item);
				var implant = {
					isVisible: true,
					name: item.name,
					length: item.length,
					diameter: item.diameter,
					defaultLength: item.length,
					defaultDiameter: item.diameter,
					focusCameraPosition: item.focusCameraPosition,
					x: item.x,
					y: item.y,
					z: item.z,
					rotationX: item.rotationX,
					rotationY: item.rotationY,
					rotationZ: item.rotationZ,
					isMaxilla: item.isMaxilla,
					dentition: item.isMaxilla ? "Maxilla" : "Mandible",
					isLoaded: false,
					isFromData: true,
					isImplant: true,
					color: this.implantsColor,
					newRotation: item.newRotation
				};

				if (item.defaultPosition) {
					implant.x = item.defaultPosition.x;
					implant.y = item.defaultPosition.y;
					implant.z = item.defaultPosition.z;
				}

				if (item.defaultRotation) {
					implant.rotationX = item.defaultRotation._x;
					implant.rotationY = item.defaultRotation._y;
					implant.rotationZ = item.defaultRotation._z;
				}

				// if (item.id > 0) {
				// 	implant.id = item.id;
				// }
				implant.id = vueApp.generateNewItemId();

				this.implants.push(implant);
				stlLogMessage(`loadImplant: ${implant.id}, ${implant.name}`);
				addImplantStl(implant);
			}
		},
		addCrown: function (implantX, implantY, implantZ, isMaxilla) {
			var crown = {
				id: this.generateNewItemId(),
				number: this.crownNumber,
				name: `Crown ${this.crownNumber}`,
				implantId: this.crownImplantId,
				implant: null,
				isVisible: true,
				x: implantX,
				y: implantY,
				z: implantZ,
				isMaxilla: isMaxilla,
				dentition: isMaxilla ? "Maxilla" : "Mandible",
				isLoaded: false,
				isFromData: false,
				stlModelLoaded: null,
				isCrown: true,
				color: vueApp.crownsColor
			};

			this.crownImplantId = null;
			this.crownNumber = null;
			this.crowns.push(crown);
			$("#globalSpinner").css({ display: "block" });
			stlLogMessage(
				`addCrown: ${crown.id}, ${crown.name}, ${implantX}, ${implantY}, ${implantZ}`
			);
			addCrownStl(crown);
		},
		loadCrown: function (crown) {
			if (crown) {
				crown.isLoaded = false;
				crown.isFromData = true;
				crown.isCrown = true;
				crown.color = vueApp.crownsColor;
				this.crowns.push(crown);
				stlLogMessage(`loadCrown: ${crown.id}, ${crown.name}`);
				addCrownStl(crown);
			}
		},
		resizeImplant: function () {
			console.log("resizeImplant");
			this.isResize = true;
			initStep2(this.lengths, this.diameters);
		},
		getItemById: function (id, guid) {
			let item = guid ? this.allItems.find(x => x.guid === guid) : null;
			if (!item) {
				item = id ? this.allItems.find(x => x.id === id) : null;
				// console.log("id item", item);
			} else {
				// console.log("guid item", item);
			}
			return item;
		},
		getItemByGuid: function (guid) {
			return guid ? this.allItems.find(x => x.guid === guid) : null;
		},
		getItemByFilename: function (filename) {
			let retval = null;
			if (filename) {
				// retval = this.allItems.find(x => x.newFileName === filename);
				// if (!retval)
				retval = this.allItems.find(x => x.filename === filename);
			}
			return retval;
		},
		getItemByMeshUuid: function (uuid) {
			return uuid ? this.allItems.find(x => x.uuid === uuid) : null;
		},
		generateNewItemId: function () {
			var allIds = this.allItems.map(function (item) {
				return item.id;
			});
			var maxId = Math.max.apply(null, allIds);
			return maxId + 1;
		},
		generateAddedTag: function (toothNumber) {
			let addedTag = "added";
			let existed = vueApp.getToothByAddedTag(toothNumber, addedTag);
			let i = 1;
			while (existed != null) {
				addedTag = `added(${i})`;
				existed = vueApp.getToothByAddedTag(toothNumber, addedTag);
				i++;
			}
			return addedTag;
		},
		getToothByName: function (name) {
			return this.allTeeth.find(x => x.name === name);
		},
		getToothByNumber: function (number) {
			number = +number;
			return this.allTeeth.find(x => x.number === number);
		},
		getToothByAddedTag: function (number, tag) {
			return this.allTeeth.find(x => x.number === number && x.addedTag === tag);
		},
		getToothByFileName: function (fileName) {
			return this.allTeeth.find(x => x.filename === fileName);
		},
		getToothByUuid: function (uuid) {
			return uuid ? this.allDents.find(x => x.uuid === uuid) : null;
		},
		getLastMolars: function (isMaxilla) {
			var tooth1 = null;
			var tooth2 = null;
			var teeth = this.allTeeth.filter(tooth => tooth.isMaxilla === isMaxilla);
			teeth.forEach(tooth => {
				if (isMaxilla) {
					if (tooth.number === 18 || (!tooth1 && tooth.number === 17)) {
						tooth1 = tooth;
					}
					if (tooth.number === 28 || (!tooth2 && tooth.number === 27)) {
						tooth2 = tooth;
					}
				} else {
					if (tooth.number === 48 || (!tooth1 && tooth.number === 47)) {
						tooth1 = tooth;
					}

					if (tooth.number === 38 || (!tooth2 && tooth.number === 37)) {
						tooth2 = tooth;
					}
				}
			});
			return tooth1 && tooth2 ? [tooth1, tooth2] : null;
		},
		getFirstIncisor: function (positionNumber) {
			var toothNumber = 0;
			if (positionNumber < 21) {
				toothNumber = 11;
			} else if (positionNumber < 31) {
				toothNumber = 21;
			} else if (positionNumber < 41) {
				toothNumber = 31;
			} else {
				toothNumber = 41;
			}
			return this.getToothByNumber(toothNumber);
		},
		getMaxOrthoStageId: function () {
			let allIds = vueApp.orthoStages.map(function (item) {
				return item.id ? item.id : 0;
			});
			let maxId = allIds.length > 0 ? Math.max.apply(null, allIds) : 0;
			return maxId;
		},
		saveData: function () {
			updateSavedData();
			saveViewerData();
		},

		showMarketing: function () {
			// this.showmarketingprompt = true;
			if (this.showmarketingprompt) {
				this.startmarketingprompt = true;
			}
		},
		leaveModes: function (toDefaultView, stayInOcclusal, preserveView) {
			vueApp.unfocusAll();
			if (vueApp.activeMode && vueApp.activeMode.leaveMode) {
				var activeMode = vueApp.activeMode;
				vueApp.activeMode = null;
				activeMode.leaveMode(true);
			}

			$("#anglePanel").css("display", "none");
			$("#orthoPlayStagesDiv").css("display", "none");
			$("#orthoTreatmentDiv").css("display", "none");
			$("#orthoTreatmentStagesDiv").css("display", "none");

			if (vueApp.isTreatmentPlayMode) {
				restoreDefaultGeometries();
				vueApp.isTreatmentPlayMode = vueApp.isTreatmentPlaying = false;
				$("#teethListBtn").css("display", "block");
				$("#teethListContainer").css("display", "block");
			}

			leaveOpacityMode();
			leaveColorMode();
			leaveHideMode();

			enableImplantsMenu();

			if (!preserveView && (!stayInOcclusal || !vueApp.isOcclusal)) {
				vueApp.resetVisibilityAndOpacity();
			}

			return;

			if (toDefaultView || (!stayInOcclusal && vueApp.isOcclusal)) {
				vueApp.switchToDefaultView();
				vueApp.isOcclusal = false;
			}
		},
		resetVisibilityAndOpacity: function (showInvisible) {
			vueApp.allItems.forEach(function (model) {
				model.isHidden = false;
				if (showInvisible)
					model.isVisible = true;
				if (model.isVisible) {
					let color = vueApp.getActualColor(model);
					itemVisibilityChanged(model, color);
					let opacity = model.opacity ? model.opacity : 1;
					if (!model.extracted)
						viewer.set_opacity(model.id, opacity);
				} else {
					viewer.set_color(model.id, "transparent");
				}
			});
			vueApp.allTeeth.forEach((model) => {
				let mesh = viewer.get_model_mesh(model.id);
				if (mesh && mesh.rootCrownMaterials && mesh.originalMaterial) {
					mesh.material = vueApp.showTeethRoots ? mesh.rootCrownMaterials : mesh.originalMaterial;
				}
				let material = mesh.originalMaterial ? mesh.originalMaterial : mesh.material;
				material.side = THREE.DoubleSide;
			});
		},
		unfocusAll: function () {
			let focusedTooth = this.getFocusedTooth();
			if (focusedTooth) {
				unfocusItem(focusedTooth);
			}
		},
		switchToDefaultView: function () {
			if (vueApp.savedData && vueApp.savedData.cameraTarget) {
				this.lookAtPoint(vueApp.savedData.cameraTarget);
			} else {
				if (defaultBox && defaultBox.center) {
					this.lookAtPoint(defaultBox.center);
				} else {
					this.lookAtPoint({ x: 0, y: 0, z: 0 });
				}
			}
			// console.log(vueApp.savedData);
			resetCameraUp();

			if (vueApp.savedData && vueApp.savedData.cameraPosition) {
				viewer.camera.position.copy(vueApp.savedData.cameraPosition);
			} else {
				if (defaultBox && defaultBox.center) {
					viewer.camera.position.x = defaultBox.center.x;
					viewer.camera.position.y = defaultBox.center.y;
				}
				else {
					viewer.camera.position.x = 0;
					viewer.camera.position.y = 0;
				}
				viewer.camera.position.z = defaultZoom;
			}

			viewer.camera.updateProjectionMatrix();
			viewer.controls.update();
			vueApp.isOcclusal = false;
		},
		saveCameraView: function () {
			this.savedCameraView =
			{
				cameraPosition: new THREE.Vector3(0, 0, 0),
				cameraTarget: new THREE.Vector3(0, 0, 0),
				color: viewer.scene.background
			};
			this.savedCameraView.cameraPosition.copy(viewer.camera.position);
			this.savedCameraView.cameraTarget.copy(viewer.controls.target);

		},
		switchToSavedCameraView: function () {
			if (this.savedCameraView) {
				viewer.scene.background = this.savedCameraView.color;
				this.lookAtPoint(this.savedCameraView.cameraTarget);

				resetCameraUp();
				viewer.camera.position.copy(this.savedCameraView.cameraPosition);

				viewer.camera.updateProjectionMatrix();
				viewer.controls.update();
			}
		},
		lookAtPoint: function (point) {
			viewer.camera.lookAt(point.x, point.y, point.z);
			viewer.controls.target = new THREE.Vector3(point.x, point.y, point.z);
		},
		getActualColor: function (model) {
			let color = "#FFFFFF";
			if (model) {
				color =
					vueApp.isRandomTeethColor &&
						model.randomColor &&
						model.randomColor != noRandomColor
						? model.randomColor
						: model.color;
			}
			return color;
		},
		isTeethListOpen: function () {
			// let display = document.getElementById('teethListBtn').style.display;
			let teethListBtnVisible = document.getElementById('teethListBtn').checkVisibility();
			return teethListBtnVisible && $(`#teethListPanel`).hasClass("show");
		},
		getFocusedTooth: function () {
			return this.allTeeth.find(t => t.isFocused);
		},
		afterStlLoad: function () {
			let totalCount = vueApp.allItems.length;
			let teethCount = vueApp.allTeeth.length;
			console.log("totalCount", totalCount, "teethCount", teethCount);

			if (teethCount > 0) {
				vueApp.downloadingStages = true;
				// loadTreatmentMatrixs();
				$("#orthoMenu").css({ display: "none" });
				downloadOrhoStages((stages) => {
					vueApp.downloadingStages = false;
					$("#orthoMenu").removeAttr("style");
					if (stages && stages.length) {
						let sorted = stages.sort((a, b) => a.id - b.id);
						sorted.forEach(stage => {
							vueApp.orthoStages.push(stage);
						});
					}
				}, false);
			}

			if (teethCount > 0 && vueApp.airways.length == 0 && vueApp.bones.length == 0 && vueApp.nerves.length == 0 && vueApp.gingivae.length == 0) {
				vueApp.isOnlyTeeth = true;
			}

			if (teethCount < 1) {
				vueApp.isNoTeeth = true;
				$("#orthoMenu").css({ display: "none" });

				// $(".menu3d").css({ display: "none" });
			}

			if (totalCount > 1 || (totalCount == 1 && vueApp.airways.length == 0)) {
				$(`#teethListContainer`).css({
					display: "block",
				});

				var isMobileOrTablet = mobileAndTabletCheck();
				if (!isMobileOrTablet) {
					$(`#teethListPanel`).addClass("show");
				}
			}

			if (teethCount > 0) {
				vueApp.allTeeth.forEach(tooth => {
					let mesh = viewer.get_model_mesh(tooth.id);
					if (mesh)
						mesh.cbctGeometry = mesh.geometry;
				});

				if (vueApp.isStitched && !vueApp.isStitching) {
					// vueApp.viewSourceType = vueApp.savedData.viewSourceType ? vueApp.savedData.viewSourceType : "stitched";
					vueApp.viewSourceType = "stitched";
					switchStitching(vueApp.viewSourceType);
				} else {
					// vueApp.viewSourceType = vueApp.savedData.viewSourceType ? vueApp.savedData.viewSourceType : "cbct";
					vueApp.viewSourceType = "cbct";
				}

				// if (vueApp.gingivae.length) {
				// 	setTimeout(function () {
				// 		loadGingivaCrossData(viewer, vueApp.gingivae, vueApp.allTeeth);
				// 	}, 500);
				// }

				if (vueApp.bones.length) { // && vueApp.hasClosedBones
					generateRootCrownMeshes();
				}
			}
		},
		reloadAppFromUrl: function (jsonUrl) {
			if (vueApp.fromShareLink) {
				let params = {
					jsonLocation: jsonUrl,
					readonly: vueApp.isViewMode,
					resetCase: vueApp.isReset,
					allowDownloads: vueApp.allowDownloads,
					cbct: vueApp.isCbctParam,
				};
				if (vueApp.recepientName)
					params.rname = vueApp.recepientName;
				if (vueApp.recepientEmail)
					params.remail = vueApp.recepientEmail;
				let paramsString = JSON.stringify(params);
				let b64 = utf8_to_b64(paramsString);
				location.href = `${location.origin}${location.pathname}?p=${b64}`;
			} else {
				location.href = `${location.origin}${location.pathname}?json_location=${jsonUrl}`;
			}
			return;

			allLoaded = stlShown = false;
			if (viewer) {
				viewer.controls.removeEventListener('change', onCameraChange);
				viewer.clean();
				viewer.renderer.domElement.remove();
				viewer = null;
			}

			if (ioViewer) {
				ioViewer.clean();
				ioViewer.renderer.domElement.remove();
				ioViewer = null;
			}

			$(`#teethListPanel`).removeClass("show");
			$id('loader').style.display = 'block';
			$id('stl_cont').style.visibility = 'hidden';
			vueApp.isStlLoaded = false;
			// $("#bottomPanel").css("display", "none");
			// vueApp.initApp(vueApp.baseObj);

			init(false, jsonUrl);
		},
		hideClipping: function () {
			if (viewer) {
				viewer.renderer.clippingPlanes = empty;
			}
		},
		restoreClipping: function () {
			if (viewer) {
				viewer.renderer.clippingPlanes =
					vueApp.savedData.clipData && vueApp.savedData.clipData.isEnabled
						? globalPlanes
						: empty;
			}
		}
	},
	computed: {
		allGroups: function () {
			var groups = this.dentations.reduce(function (a, b) {
				return a.concat(b.groups);
			}, []);
			return groups.length > 0 ? groups.sort(sortByName) : groups;
		},
		allTeeth: function () {
			return this.allGroups.reduce(function (a, b) {
				return a.concat(b.teeth);
			}, []);
		},
		allItems: function () {
			return this.bones
				.concat(this.nerves)
				.concat(this.gingivae)
				.concat(this.airways)
				.concat(this.allTeeth)
				.concat(this.implants)
				.concat(this.crowns);
		},
		teethMeshes: function () {
			return this.allTeeth.map(model => viewer.get_model_mesh(model.id));
		},
		allMeshes: function () {
			return this.bones
				.concat(this.nerves)
				.concat(this.gingivae)
				.concat(this.airways)
				.concat(this.allTeeth)
				.concat(this.implants)
				.concat(this.crowns).map(model => viewer.get_model_mesh(model.id));
		},
		allDents: function () {
			return this.allTeeth.concat(this.implants).concat(this.crowns);
		},
		maxillaBone: function () {
			return this.bones.find(b => b.isMaxilla);
		},
		mandibleBone: function () {
			return this.bones.find(b => !b.isMaxilla);
		},
		cbctStages: function () {
			return this.orthoStages.filter((stage) => !stage.isIntraoral);
		},
		intraoralStages: function () {
			return this.orthoStages.filter((stage) => stage.isIntraoral);
		},
		currentStages: function () {
			let retval = this.orthoStages.filter((stage) => stage.isIntraoral == this.isIntraoralView);
			// console.log("currentStages", retval);
			return retval;
		}
	},
	mounted: function () { }
};

//#region Fields

let isMouseDown = false;
let mouseDownEvent = null;
let highlightedTooth = null;

let cbctMenu = null;
let cbctColorBtn = null;
let cbctChangeBtn = null;
let cbctDeleteBtn = null;
let cbctFocusBtn = null;
let cbctHideBtn = null;
let cbctResetInitialBtn = null;
let cbctResetCurrentBtn = null;

let selectedTooth = null;
let taggedControl = null;

//#endregion

window.addEventListener("DOMContentLoaded", function () {
	console.log(cephxVersion);

	const urlParams = new URLSearchParams(window.location.search);
	const defaultParam = urlParams.get("default");
	const lqParam = urlParams.get("lq");
	if (lqParam && lqParam === "true") {
		vueApp.isHighQuality = false;
	}

	const demoParam = urlParams.get("demo");
	if (demoParam !== null) {
		vueApp.isDemo = true;
	}

	const engineerParam = urlParams.get("engineerMode");
	if (engineerParam !== null) {
		vueApp.isEngineerMode = true;
	}

	const sharedParams = urlParams.get("p");
	if (sharedParams) {
		vueApp.fromShareLink = true;
		vueApp.isShareEnabled = false;
		var jsonParams = b64_to_utf8(sharedParams);
		var params = JSON.parse(jsonParams);
		vueApp.jsonLocation = params.jsonLocation;
		console.log("jsonParams", params);
		vueApp.isViewMode = params.readonly;
		vueApp.isReset = params.resetCase;
		vueApp.allowDownloads = params.allowDownloads;
		if (params.cbct)
			vueApp.isCbctParam = params.cbct;
		vueApp.isAnonymized = params.anonymized === undefined || params.anonymized;
		if (params.rname) {
			vueApp.recepientName = params.rname;
			console.log(vueApp.recepientName);
		}
		if (params.remail) {
			vueApp.recepientEmail = params.remail;
			console.log(vueApp.recepientEmail);
		}
	} else {
		vueApp.jsonLocation = urlParams.get("json_location");
		vueApp.isViewMode = urlParams.get("save") === "false";
		const reset = urlParams.get("reset");
		vueApp.isReset = reset && reset.toLowerCase() == "true";

		const cbctParam = urlParams.get("cbct");
		vueApp.isCbctParam = cbctParam && cbctParam === "true";
	}

	vueApp.showmarketingprompt = urlParams.get("showmarketingprompt") === "true";
	var temp = urlParams.get("opennewtabprompt");
	if (temp) {
		vueApp.opennewtabprompt = temp;
	}

	if (window.caches) {
		window.caches.open("cephxStlCache").then(function (cache) {
			vueApp.cache = cache;
			init(defaultParam, vueApp.jsonLocation);
		});
	} else {
		init(defaultParam, vueApp.jsonLocation);
	}

	$(window).resize(function (e) {
		onCameraChange();
	});

	$("#main_div").on("contextmenu", "img", function (e) {
		return false;
	});

	// $("li.dropdown")
	$("a.nav-link").on("mousedown", function () {
		$(".secondary-menu").removeClass("show");
	});

	stl_cont = document.getElementById("stl_cont");
	if (isTouchEnabled()) {
		stl_cont.addEventListener("touchstart", function (e) {
			var event = e.targetTouches[0];
			onDocumentMouseDown(event);
		});
		stl_cont.addEventListener("touchmove", function (e) {
			var event = e.targetTouches[0];
			onDocumentMouseMove(event);
		});
		stl_cont.addEventListener("touchend", function (e) {
			var event = e.changedTouches[0];
			onDocumentMouseUp(event);
		});
	} else {
		//stl_cont.addEventListener("click", onDocumentClick, false);
		stl_cont.addEventListener("mousedown", onDocumentMouseDown, false);
		stl_cont.addEventListener("mousemove", onDocumentMouseMove, false);
		stl_cont.addEventListener("mouseup", onDocumentMouseUp, false);
		stl_cont.addEventListener("dblclick", onDocumentDblClick, false);

		cbctMenu = document.getElementById("cbct-tooth-menu");
		stl_cont.appendChild(cbctMenu);

		cbctColorBtn = document.getElementById("cbct-color-btn");
		cbctColorBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			if (selectedTooth)
				openColorPicker(selectedTooth.id)
		});

		cbctChangeBtn = document.getElementById("cbct-change-btn");
		cbctChangeBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			editItemSettings(selectedTooth);
		});

		cbctFocusBtn = document.getElementById("cbct-focus-btn");
		cbctFocusBtn.addEventListener("click", (event) => {
			// if (event.stopPropagation) {
			// 	event.stopPropagation();
			// 	event.preventDefault();
			// }
			cbctMenu.style.display = "none";
			if (!selectedTooth.isFocused)
				focusItem(selectedTooth);
			else
				unfocusItem();
		});

		cbctHideBtn = document.getElementById("cbct-hide-btn");
		cbctHideBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			if (selectedTooth) {
				selectedTooth.isVisible = !selectedTooth.isVisible;
				itemVisibilityChanged(selectedTooth, selectedTooth.color, vueApp.teethOpacity);
			}
		});

		cbctDeleteBtn = document.getElementById("cbct-delete-btn");
		cbctDeleteBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			deleteItem(selectedTooth);
		});

		cbctResetInitialBtn = document.getElementById("cbct-reset-initial-btn");
		cbctResetInitialBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			console.log("cbctResetInitialBtn");
			resetToInitial(selectedTooth);
		});

		cbctResetCurrentBtn = document.getElementById("cbct-reset-current-btn");
		cbctResetCurrentBtn.addEventListener("click", () => {
			cbctMenu.style.display = "none";
			console.log("cbctResetCurrentBtn");
			resetToCurrent(selectedTooth);
		});
	}

	const loader = new THREE.FontLoader();
	loader.load('fonts/helvetiker_regular.typeface.json', function (font) {
		vueApp.defaultFont = font;
	});
});

function onDocumentDblClick(event) {
	updateRaycaster(event);
	selectedTooth = intersectTooth(null, event);
	if (selectedTooth) {
		cbctHideBtn.style.display =
			selectedTooth.isVisible ? "initial" : "none";

		cbctResetInitialBtn.style.display =
			cbctResetCurrentBtn.style.display =
			vueApp.activeMode == opmode ? "initial" : "none";

		cbctFocusBtn.innerHTML = selectedTooth.isFocused ? "Unfocus Tooth" : "Focus Tooth";
		cbctMenu.style.display = "initial";
		cbctMenu.style.left = event.offsetX + 1 + "px";
		cbctMenu.style.top = event.offsetY + 1 + "px";
	}
}

function isTouchEnabled() {
	return ('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0);
}

function init(defaultParam, jsonLocation) {
	if (defaultParam && defaultParam === "true") {
		initModel(defaultObject);
	} else if (jsonLocation) {
		fetch(jsonLocation, {
			cache: "no-cache"
		})
			.then(function (response) {
				response.text().then(async (text) => {
					let model = JSON.parse(text);
					// console.log("model 1", model);
					if (model.data && !model.data.areGuidsSet) {
						let tempModel = await sendSetGuidsRequest();
						if (tempModel)
							model = tempModel;
					}
					setS3BaseUrls();
					await checkIsStitched();
					await checkHasDicom();
					// console.log("model 2", model);
					initModel(model);
				});
			})
			.catch(error => {
				console.error("Error in main JSON download: ", error);
			});
	} else {
		// $id("open_json").style.display = "block";
		vueApp.showMarketing();
	}
}

function setS3BaseUrls() {
	let arr = vueApp.jsonLocation.split("/");
	arr.pop();
	vueApp.s3dicom = arr[arr.length - 1];
	vueApp.stlBaseUrl = arr.join('/');
	const index = arr.indexOf('STL');
	arr.splice(index, 1);
	vueApp.s3Url = arr.slice(0, arr.length - 1).join('/');
	// console.log("s3Url: ", vueApp.s3Url);
	vueApp.dicomUrl = arr.join('/');
	console.log("dicomUrl: ", vueApp.s3dicom, vueApp.stlBaseUrl, vueApp.dicomUrl);
}

function updateRaycaster(event) {
	try {
		if (!raycaster) {
			var direction = getMouse3dDirection(event);
			raycaster = new THREE.Raycaster(
				viewer.camera.position, // origin
				direction,
				0.1,
				100000
			);
		} else {
			var direction = getMouse3dDirection(event);
			raycaster.set(viewer.camera.position, direction);
		}
	} catch (error) {
		// console.error("updateRaycaster", error);
	}
}

function intersectTooth(selectedId) {
	var tooth = null;
	try {
		var intersects = raycaster.intersectObjects(vueApp.teethMeshes); //viewer.scene.children);
		if (intersects.length > 0) {
			//var intersectPoint = null;
			intersects.find(intersect => {
				//intersectPoint = intersect.point;
				var objectUuid = intersect.object.uuid;
				tooth = vueApp.getToothByUuid(objectUuid);
				let retval = tooth != null && !tooth.isHidden && (!selectedId || tooth.id == selectedId)
				return retval;
			});

			if (tooth) {
				if (!tooth.isVisible && !vueApp.isHideMode) {
					tooth = null;
				}
				//event.intersectPoint = intersectPoint;
				//drawPoint(intersectPoint);
			}
		}
	} catch (error) {
		stlLogMessage(error);
	}

	return tooth;
}

function findTaggedControl(tagParam = "group", isHighlight, isShift) {
	// need precall -  updateRaycaster(event);
	let combinedArray = [];
	let taggedMeshes = [];
	viewer.scene.children.forEach(element => {
		if (element.tag == tagParam) {
			taggedMeshes.push(...element.children);
		}
	});
	combinedArray.push(...taggedMeshes);
	combinedArray.push(...vueApp.teethMeshes);
	let intersects = raycaster.intersectObjects(combinedArray);
	let intersectPoint = null;
	let intersectTagged = null;
	// intersectTagged = intersects.find(intersect => {
	// 	intersectPoint = intersect.point;
	// 	return intersect.object.tag != undefined;
	// });

	let intersectFirst = intersects.length > 0 ? intersects[0] : null;
	if (intersectFirst && intersectFirst.object.tag != undefined) {
		// console.log("findTaggedControl", intersectFirst);

		intersectPoint = intersectFirst.point;
		intersectTagged = intersectFirst;
	}

	if (taggedControl != intersectTagged) {
		taggedMeshes.forEach((child) => {
			if (child.defaultColor) {
				child.material.color = new THREE.Color(child.defaultColor);
			}
		});
		document.body.style.cursor = "default";

		if (intersectTagged) {
			document.body.style.cursor = "pointer";
			intersectTagged.object.material.color = new THREE.Color(0xffff00);
		}
		taggedControl = intersectTagged;
	}

	if (intersectTagged && !isHighlight && vueApp.activeMode.tagDetected)
		vueApp.activeMode.tagDetected(intersectTagged.object.tag, intersectTagged.object, isShift, intersectPoint);

	return intersectTagged;
}

function onDocumentMouseDown(event) {
	if (cbctMenu && cbctMenu.style && cbctMenu.style.display == "initial") {
		return;
	}
	isMouseDown = true;
	mouseDownEvent = event;
	if (event.button && event.button > 0) {
		return;
	}
	var inMode =
		vueApp.activeMode &&
		vueApp.activeMode.isActive &&
		(vueApp.activeMode.toothSelected ||
			vueApp.activeMode.tagDetected ||
			vueApp.activeMode.mouseDown);
	if (inMode) {
		if (vueApp.activeMode.mouseDown) {
			vueApp.activeMode.mouseDown(event);
		} else {
			updateRaycaster(event);
			var selectedId = vueApp.activeMode.selectedId;
			if (selectedId) {
				const isShift = event.shiftKey;
				// console.log("isShift", isShift);
				var tagged = findTaggedControl("group", false, isShift);
				if (tagged) return true;
			}
		}
	}
	return false;
}

function onDocumentMouseMove(event) {
	try {
		if (vueApp.isHidden) return;

		if (cbctMenu.style.display == "initial") {
			return;
		}

		let needHighlight = false;
		if (
			vueApp.activeMode &&
			vueApp.activeMode.isActive &&
			vueApp.activeMode.mouseMove
		) {
			needHighlight = vueApp.activeMode.mouseMove(event);
		}

		if (
			(vueApp.isColorMode && !teethColorMouseDown) ||
			vueApp.isHideMode ||
			needHighlight ||
			vueApp.isDicomOpen ||
			vueApp.isTeethListOpen()
		) {
			if ((event.buttons && event.buttons > 0) || vueApp.getFocusedTooth()) {
				return;
			}
			updateRaycaster(event);
			if (vueApp && vueApp.activeMode && vueApp.activeMode.tagDetected) {
				findTaggedControl("group", true);
			}
			var tooth = intersectTooth(null, event);
			if (highlightedTooth != tooth) {
				if (tooth) {
					highlightedTooth = tooth;
					if (!vueApp.isHideMode)
						highlightedTooth.isHovered = true;
					setHighlightedToothColor(highlightedTooth);
				}
				if (highlightedTooth) {
					vueApp.allTeeth.forEach(function (model) {
						if (model != tooth) {
							if (!vueApp.isHideMode)
								model.isHovered = false;
							if ((model.isVisible || vueApp.isHideMode) && !model.isHidden) {
								let color = vueApp.getActualColor(model);
								viewer.set_color(model.id, color);
							}
						}
					});
					highlightedTooth = tooth;
				}
				if (vueApp.activeMode && vueApp.activeMode.toothEnter) {
					vueApp.activeMode.toothEnter(highlightedTooth);
				}

				if (vueApp.isDicomOpen) {
					highlightOutlines(highlightedTooth);
				}
			}
		}
	} catch (error) {
		console.log("onDocumentMouseMove", error);
	}
}

function onDocumentMouseUp(event) {
	document.body.style.cursor = "default";
	if (cbctMenu && cbctMenu.style) {
		cbctMenu.style.display = "none";
	}
	$("#anglePanel").fadeOut();
	updateRaycaster(event);
	var tooth = intersectTooth(null, event);
	if (tooth) {
		tooth.isClicked = true;
	}

	let needClick = false;
	if (vueApp.activeMode && vueApp.activeMode.isActive) {
		if (vueApp.activeMode.mouseUp) {
			needClick = vueApp.activeMode.mouseUp(event);
		}
		needClick = needClick || vueApp.activeMode.toothSelected;
	}

	if (vueApp.isColorMode || vueApp.isHideMode || needClick) {
		if (event.button && event.button > 0) {
			return;
		}
		if (isMouseDown) {
			var distance = calculateEventDistance(mouseDownEvent, event);
			if (distance < 1) {
				if (vueApp.isColorMode || vueApp.isHideMode) {
					if (tooth) {
						onToothUp(tooth);
						// if (event.stopPropagation) {
						// 	event.stopPropagation(); //	event.preventDefault();
						// }
					}
				} else {
					if (vueApp.activeMode.toothSelected) {
						vueApp.activeMode.toothSelected(tooth, event);
					}
					if (vueApp.activeMode.mouseClick) {
						vueApp.activeMode.mouseClick(event);
					}
				}
			}
		}
	}
	isMouseDown = false;
}

function onToothUp(item) {
	if (!item)
		return;
	if (vueApp.isHideMode) {
		item.isVisible = !item.isVisible;
		viewer.set_opacity(item.id, item.isVisible ? 1 : 0.3); // 2.1 - 2.2
		// viewer.set_color(item.id, hideModeTeethColor);
		vueApp.$emit('visibilityChanged', item);
	} else if (vueApp.isColorMode) {
		if (item.isVisible) {
			setTimeout(function () {
				openColorPicker(item.id);
			}, 100);
		}
	}
}

function setHighlightedToothColor(hTooth) {
	if (hTooth && !hTooth.isHidden) {
		let color = vueApp.getActualColor(hTooth);
		if (color.toLowerCase() == "#ffffff") {
			viewer.set_color(hTooth.id, greyTeethColor);
		} else {
			var mesh = viewer.get_model_mesh(hTooth.id);
			var rgb = mesh.material.color;
			var r = Math.min(1.0, rgb.r + 0.2);
			var g = Math.min(1.0, rgb.g + 0.2);
			var b = Math.min(1.0, rgb.b + 0.2);
			mesh.material.color.setRGB(r, g, b);
		}
	}
}

function calculateEventDistance(event1, event2) {
	var x1 = event1.clientX;
	var x2 = event2.clientX;
	var a = x1 - x2;
	var y1 = event1.clientY;
	var y2 = event2.clientY;
	var b = y1 - y2;
	return Math.hypot(a, b); //Math.sqrt(a*a + b*b);
}

export {
	updateRaycaster, findTaggedControl, intersectTooth, setHighlightedToothColor, isTouchEnabled
};
</script>

<style>
@import "css/editControls.css";

#isStitchingHint {
	width: 250px;
	top: 7px;
	right: 25px;
	position: absolute;
	background-color: transparent;
	color: white;
	/* font-weight: bold; */
	text-align: center;
	font-size: 16px;
	font-family: Montserrat, sans-serif;
}

.progress-small-img {
	display: inline;
	width: 29px;
	height: 29px;
}

.tooth-menu {
	font-size: 14px;
	font-family: Montserrat, sans-serif;
	display: none;
	position: absolute;
	width: auto;
	background-color: white;
	box-shadow: 0 0 5px grey;
	border-radius: 3px;
	z-index: 999;
	max-width: 140px;
}

.tooth-menu .tooth-menu-btn {
	width: 100%;
	background-color: #4687fc;
	color: white;
	margin: 0;
	padding: 5px;
	border: 0;
	border-top: 1px solid #D9E6FE;
}

.tooth-menu>.tooth-menu-btn:first-child {
	border: 0;
}

#selectColorControl {
	position: fixed;
	opacity: 0;
	width: 1px;
	height: 1px;
	left: calc(50% - 97px);
	top: calc(50% - 145px);
}

.teeth-list-btn {
	cursor: pointer;
	position: absolute;
	top: 5px;
	right: 12px;
	width: 30px;
	height: 30px;
	z-index: 1000;
}

.switch-view-btn {
	position: absolute;
	width: 28px;
	height: 25px;
	cursor: pointer;
	top: 14px;
}

/* #segmented_view_btn {
	left: 14px;
	top: 14px;
} */

.cbct-zoom-container {
	position: absolute;
	text-align: center;
	left: 12px;
	top: 14px;
}

.cbct-zoom-btn {
	width: 20px;
	height: 20px;
	margin-right: 10px;
	/* margin-bottom: 12px; */
	color: white;
	cursor: pointer;
	/* font-size: 2rem; */
}

#dicom_view_btn {
	left: 72px;
}

#split_view_btn {
	left: 110px;
	height: 26px;
}

#loader {
	z-index: 1004;
}

#views_cont {
	width: 100%;
}

.flex-container {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	height: calc(100% - 35px);
	background: white;
	gap: 4px;
}

.flex-item {
	text-align: center;
	flex-grow: 1;
	box-sizing: border-box;
}

#views3d_wrapper {
	position: relative;
	display: block;
	margin: 0 auto;
	width: 100%;
	height: 100%;
	background: #082F5E;
	/* background: #77a7fd; */
}

#views3d_cont {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: stretch;
	margin: 0 auto;
	width: 100%;
	height: 100%;
	background: white;
	gap: 2px;
}

.view-flex-item {
	text-align: center;
	flex-grow: 1;
	box-sizing: border-box;
}

#stl_wrapper {
	position: relative;
	margin: 0 auto;
	width: calc(50% - 1px);
	height: 100%;
	background: #082F5E;
	/* background: #77a7fd; */
}

#dicom_3d_wrapper {
	position: relative;
	margin: 0 auto;
	width: calc(50% - 1px);
	height: 100%;
	font-size: 30px;
}

#stl_cont {
	margin: 0 auto;
	visibility: hidden;
	width: 100%;
	height: 100%;
}

/* .layer {
  position: absolute;
  pointer-events: none;
} */

#trademarkImg {
	position: absolute;
	left: 10px;
	bottom: 27px;
	z-index: 9;
	height: 25px;
}

#copyrightText {
	position: absolute;
	left: 10px;
	bottom: 7px;
	z-index: 9;
	color: #ffffff;
	font-size: x-small;
}

@media (max-width: 430px) {
	#trademarkImg {
		height: 20px;
		left: 5px;
		bottom: 20px;
	}

	#copyrightText {
		left: 5px;
		bottom: 2px;
	}
}

#infoImgBtm {
	position: absolute;
	left: 93px;
	bottom: 29px;
	z-index: 9;
	height: 30px;
	cursor: pointer;
}

.swal-wide {
	width: auto;
}

.swal-content {
	margin-top: 25px;
	margin-bottom: 15px;
}

.dropdown-menu {
	z-index: 99999;
}

#viewModeHint {
	position: absolute;
	width: 250px;
	left: calc(50% - 125px);
	top: 15px;
	background-color: transparent;
	color: red;
	font-weight: bold;
	text-align: center;
}

.centered-spinner {
	width: 100px;
	height: 100px;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-left: -50px;
	margin-top: -50px;
	display: none;
	text-align: center;
	z-index: 9;
}

.slick-prev:before,
.slick-next:before {
	color: #0069d9;
}

.slider .slick-list .slick-slide {
	margin: 0 4px;
}

#tooltip {
	position: fixed;
	left: 0;
	top: 0;
	min-width: 100px;
	text-align: center;
	padding: 5px 12px;
	font-family: monospace;
	background: #a0c020;
	display: none;
	opacity: 0;
	border: 1px solid black;
	box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
	transition: opacity 0.25s linear;
	border-radius: 3px;
}

.implant-disabled:disabled {
	color: #6c757d !important;
	text-decoration: none;
	background-color: transparent;
	pointer-events: none;
}

.annotation-menu {
	font-size: 14px;
	font-family: Montserrat, sans-serif;
	display: none;
	position: absolute;
	width: auto;
	background-color: white;
	box-shadow: 0 0 5px grey;
	border-radius: 3px;
	max-width: 150px;
	z-index: 999;
}

.annotation-menu>button {
	width: 100%;
	background-color: #4687fc;
	color: white;
	border: none;
	margin: 0;
	padding: 5px;
	border-top: 1px solid #D9E6FE;
}

.annotation-menu>button:first-child {
	border-top: 0;
}

.annotation-menu button:hover {
	background-color: rgb(182, 182, 182);
}
</style>
